import * as React from 'react';
import './PortableStats.css';
import { useSelector } from 'react-redux';
import { selectGeneralStats, selectPlayerToShowStats } from '../../selectors';
import PortableBasicStats from '../PortableBasicStats/PortableBasicStats';
import { PreflopStatsList } from '../PreflopStats/PreflopStats';
import PostflopStats from '../PostflopStats/PostflopStats';
import PortableChart from '../PortableChart/PortableChart';

const PortableStats = React.memo(() => {
  const playerToShowStats = useSelector(selectPlayerToShowStats);
  const generalStats = useSelector(selectGeneralStats);

  if (!playerToShowStats) {
    return null;
  }

  return (
    <div className="PortableStats">
      <section className="PortableStats__overview">
        <PortableBasicStats />

        <div className="PortableStats__overview-divider" />

        <div className="PortableStats__preflop-row">
          <div className="PortableStats__preflop-grid">
            <div className="PortableStats__preflop-col">
              <PreflopStatsList
                overview
                names={['3bet', 'F3bet', 'SQZ']}
                values={[
                  generalStats.threebet ?? null,
                  generalStats.foldedtothreebetpreflop ?? null,
                  generalStats.squeeze ?? null,
                ]}
              />
            </div>
            <div className="PortableStats__preflop-col">
              <PreflopStatsList
                overview
                names={['4bet', 'F4bet', '5bet']}
                values={[
                  generalStats.raisedthreebetpreflop ?? null,
                  generalStats.foldedtofourbetpreflop ?? null,
                  generalStats.raisedfourbetpreflop ?? null,
                ]}
              />
            </div>
            <div className="PortableStats__preflop-col">
              <PreflopStatsList
                overview
                names={['WTSD', 'WWSF', 'W$SD']}
                values={[
                  generalStats.sawshowdown ?? null,
                  generalStats.wonwhensawflop ?? null,
                  generalStats.wonshowdown ?? null,
                ]}
              />
            </div>
          </div>

          <div className="PortableStats__preflop-chart">
            <PortableChart mini />
          </div>
        </div>
      </section>

      <PostflopStats portable />
    </div>
  );
});

export default PortableStats;
